import { Button, Modal } from "antd";
import React, { ReactNode, useEffect, useState } from "react";
import close from "../../../assets/images/close.svg";
import icon from "../../../assets/images/modal-icon-offer.svg";
import { FormValuesAcceptance } from "../../../core/models/custom/formValuesAcceptance";
import { OfferValue } from "../../../core/models/custom/offerValue";
import { CardDto } from "../../../core/models/dtos/card.dto";
import { MeDto } from "../../../core/models/dtos/me.dto";
import { ApiEvent } from "../../../core/models/enums/apiEvent";
import { Operator } from "../../../core/models/enums/operator";
import { apiEventRequest } from "../../../core/services/eventService/apiEvent/repository";
import FirebaseService from "../../../core/services/firebaseService/firebase.service";
import { Helpers } from "../../../core/utilities/helpers";
import { UI } from "../../../core/utilities/ui";
import FirebaseKey from "../../FirebaseKey/FirebaseKey";
import Humps from "../../Humps/Humps";
import Loading from "../../Loading/Loading";
import AcceptanceForm from "./AcceptanceForm/AcceptanceForm";
import "./OfferModal.scss";
import SavedCard from "./SavedCard/SavedCard";

interface IProps {
  me?: MeDto;
  offer: OfferValue;
  isLoading: boolean;
  isLoadingCardDelete: boolean;
  type: PaymentModalType;
  callbackChangeType: (type: PaymentModalType) => void;
  callbackDeleteSavedCard: () => void;
  callbackApprovalSavedCard: (isBuyForHump: boolean, card?: CardDto) => void;
  callbackApprovalAcceptance: (
    isBuyForHump: boolean,
    values?: FormValuesAcceptance
  ) => void;
  callbackApprovalMobile: (isBuyForHump: boolean) => void;
  callbackCancel: () => void;
}

export enum PaymentModalType {
  payment = "payment",
  paymentMobile = "paymentMobile",
  ccSave = "ccSave",
}

const OfferModal = (props: IProps) => {
  const [isBuyForHump, setIsBuyForHump] = useState(
    !props.me?.multipleAnswerLimitReached
  );
  const isNewcomer = !props.me?.firstTimeSavedCardDate;
  const isBuyForHumpDisabled = !!props.me?.multipleAnswerLimitReached;
  const isTurkcell = props.me?.operator === Operator.TURKCELL;
  const isMobileOffer = props.type === PaymentModalType.paymentMobile;

  useEffect(() => {
    if (isNewcomer) {
      FirebaseService.logEvent(FirebaseService.free_offer_view_count);
    } else {
      FirebaseService.logEvent(FirebaseService.offer_view_count);
    }
    apiEventRequest({
      ...Helpers.getApiEventCoreData(props.me),
      event: ApiEvent.OFFER_POP_UP_VIEW,
      value1: !isNewcomer ? props.offer.id : undefined,
      value3: isNewcomer ? "FREE" : undefined,
    }).catch();
  }, [isNewcomer, props.me, props.offer.id]);

  const buyForHumpForCallback = (logEvent: boolean): boolean => {
    const buyForHump = isNewcomer ? false : isBuyForHump;
    if (logEvent) {
      if (buyForHump) {
        FirebaseService.logEvent(FirebaseService.user_count_offer_triple);
        apiEventRequest({
          ...Helpers.getApiEventCoreData(props.me),
          event: ApiEvent.OFFER_TRIPLE,
        }).catch();
      } else {
        FirebaseService.logEvent(FirebaseService.user_count_offer_single);
        apiEventRequest({
          ...Helpers.getApiEventCoreData(props.me),
          event: ApiEvent.OFFER_SINGLE,
        }).catch();
      }
    }
    return buyForHump;
  };

  const handleChangePaymentMethod = (): void => {
    props.callbackChangeType(
      props.type === PaymentModalType.payment
        ? PaymentModalType.paymentMobile
        : PaymentModalType.payment
    );
  };

  const renderContentNewcomer = () => {
    return (
      <>
        <img className="icon" src={icon} alt="icon" />
        <FirebaseKey
          className="title"
          firebaseKey={FirebaseService.cc_header_first_time_text}
        />
        <FirebaseKey
          className="text"
          firebaseKey={FirebaseService.cc_description_first_time_text}
        />
      </>
    );
  };

  const renderContent = () => {
    return (
      <>
        {isMobileOffer ? (
          <>
            <FirebaseKey
              className="title"
              firebaseKey={FirebaseService.mobile_payment_offer_popup_title}
            />
            <FirebaseKey
              className="text"
              firebaseKey={FirebaseService.mobile_payment_offer_popup_desc}
            />
          </>
        ) : (
          <>
            <FirebaseKey className="title" firebaseKey={props.offer.header} />
            <FirebaseKey
              className="text"
              firebaseKey={props.offer.description}
            />
          </>
        )}
        <Humps
          isLoading={props.isLoading}
          isBuyForHump={isBuyForHump}
          isBuyForHumpDisabled={isBuyForHumpDisabled}
          callbackChange={setIsBuyForHump}
        />
      </>
    );
  };

  const renderAction = (): ReactNode => {
    if (!isMobileOffer) {
      return props.me?.card ? (
        <SavedCard
          isNewcomer={isNewcomer}
          offer={props.offer}
          card={props.me.card}
          isLoading={props.isLoading}
          isLoadingCardDelete={props.isLoadingCardDelete}
          callbackDelete={props.callbackDeleteSavedCard}
          callbackApproval={(card) => {
            if (card) {
              FirebaseService.logEvent(
                FirebaseService.user_count_continue_button_clicked
              );
              apiEventRequest({
                ...Helpers.getApiEventCoreData(props.me),
                event: ApiEvent.CONTINUE_BUTTON_CLICKED,
              }).catch();
              // FirebaseService.logEvent(FirebaseService.user_count_charge_saved_card_continue_button_clicked);
              if (isNewcomer) {
                apiEventRequest({
                  ...Helpers.getApiEventCoreData(props.me),
                  event: ApiEvent.PAYMENT_REQUEST_FREE,
                  value3: "FREE",
                }).catch();
              } else {
                apiEventRequest({
                  ...Helpers.getApiEventCoreData(props.me),
                  event: ApiEvent.CHARGE_SAVED_CARD_REQUEST,
                  value1: props.offer.id,
                  value2: isBuyForHump ? 3 : 1,
                }).catch();
              }
            }
            props.callbackApprovalSavedCard(isBuyForHump, card);
          }}
        />
      ) : (
        <AcceptanceForm
          isNewcomer={isNewcomer}
          isTurkcell={isTurkcell}
          isBuyForHumpDisabled={isBuyForHumpDisabled}
          offer={props.offer}
          isLoading={props.isLoading}
          callbackApproval={(values) => {
            if (values) {
              FirebaseService.logEvent(
                FirebaseService.user_count_continue_button_clicked
              );
              apiEventRequest({
                ...Helpers.getApiEventCoreData(props.me),
                event: ApiEvent.CONTINUE_BUTTON_CLICKED,
              }).catch();
              if (!!values?.saveCard) {
                if (isNewcomer) {
                  // FirebaseService.logEvent(FirebaseService.free_user_count_continue_button_clicked);
                } else {
                  // FirebaseService.logEvent(FirebaseService.user_count_save_card_continue_button_clicked);
                  apiEventRequest({
                    ...Helpers.getApiEventCoreData(props.me),
                    event: ApiEvent.PAYMENT_REQUEST_CC,
                    value1: props.offer.id,
                    value2: isBuyForHump ? 3 : 1,
                  }).catch();
                }
              } else {
                // FirebaseService.logEvent(FirebaseService.user_count_continue_button_clicked);
                apiEventRequest({
                  ...Helpers.getApiEventCoreData(props.me),
                  event: ApiEvent.VPOS_START_PAYMENT_REQUEST,
                  value1: props.offer.id,
                }).catch();
              }
            }
            props.callbackApprovalAcceptance(isBuyForHump, values);
          }}
        />
      );
    }
    const mobileButton = isBuyForHumpDisabled ? (
      "DEVAM ET"
    ) : (
      <FirebaseKey
        firebaseKey={FirebaseService.mobile_payment_offer_popup_button}
      />
    );
    return (
      <Button
        className="app-button"
        disabled={props.isLoading}
        onClick={() => {
          apiEventRequest({
            ...Helpers.getApiEventCoreData(props.me),
            event: ApiEvent.MOBILE_START_PAYMENT_REQUEST,
            value1: props.offer.id,
          }).catch();
          props.callbackApprovalMobile(buyForHumpForCallback(isBuyForHump));
        }}
      >
        {props.isLoading ? <Loading fontSize={20} /> : mobileButton}
      </Button>
    );
  };

  const renderChangePaymentMethod = (): ReactNode => {
    if (isTurkcell && !isNewcomer) {
      return (
        <Button
          className="link-button"
          disabled={props.isLoading}
          onClick={handleChangePaymentMethod}
        >
          Ödeme yöntemini değiştir
        </Button>
      );
    }
    return <React.Fragment />;
  };

  return (
    <Modal
      className="offer-modal"
      maskStyle={UI.modalMaskStyle()}
      visible
      closable={!isNewcomer}
      closeIcon={
        <img
          src={close}
          alt="close"
          onClick={!props.isLoading ? props.callbackCancel : () => {}}
        />
      }
      footer={false}
      centered
      destroyOnClose
    >
      <div className="content">
        {/* {
          isNewcomer
            ? renderContentNewcomer()
            : renderContent()
        } */}
        {renderContent()}
        {renderAction()}
        {renderChangePaymentMethod()}
      </div>
    </Modal>
  );
};

export default OfferModal;
